import {ConfigObjectType} from '@wallaby-ui/core';
import * as React from 'react';

import {PhDrugRelatedProblemDto} from './PhRecommendationDrpBaseFormatter';
import {PhRecommendationDrpTextFormatter, useDRPMedicationData} from './PhRecommendationDrpFormatters';

type Props = {
  problems: PhDrugRelatedProblemDto[];
  dividerWidthOffset: number;
  config: ConfigObjectType;
};
export const PhRecommendationDrpMedicationFormatter: React.FC<Props> = ({problems, dividerWidthOffset, config}) => {
  const {getDRPMedicationData} = useDRPMedicationData(config);
  return (
    <PhRecommendationDrpTextFormatter
      dividerWidthOffset={dividerWidthOffset}
      problems={problems}
      getText={(drp) => getDRPMedicationData(drp)?.fullMedicationLabel}
    />
  );
};

PhRecommendationDrpMedicationFormatter.displayName = 'PhRecommendationDrpMedicationFormatter';
